import { useState } from 'react';

/*
The MatchesCoupon seeAllOdds link text and the bet column header labels text
are now dynamic and coming from translations.
This allows the label headers to maintain alignment with bet columns.
*/

export const useDynamicAlignLabelsAndBets = () => {
  const defaultSeeAllOddsLinkContainerWidth = 117;
  const [groupTitleLabelsMarginRight, setGroupTitleLabelsMarginRight] = useState(defaultSeeAllOddsLinkContainerWidth);

  const defaultBetsWrapperWidth = 130;
  const [betsWrapperWidth, setBetsWrapperWidth] = useState(defaultBetsWrapperWidth);

  return {
    betsWrapperWidth,
    groupTitleLabelsMarginRight,
    setBetsWrapperWidth,
    setGroupTitleLabelsMarginRight,
  };
};
